import React, { FC } from 'react';

import styles from './skeleton.module.scss';

export const Skeleton: FC = () => <div className={styles.skeletonAnimation} />;
